import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "fb",
  "use": "fb-usage",
  "viewBox": "0 0 12 12",
  "content": "<symbol viewBox=\"0 0 12 12\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"fb\">\n<path d=\"M10.2422 0H1.75781C0.788635 0 0 0.788635 0 1.75781V10.2422C0 11.2114 0.788635 12 1.75781 12H5.29688V7.75781H3.89062V5.64844H5.29688V4.21875C5.29688 3.05557 6.24307 2.10938 7.40625 2.10938H9.53906V4.21875H7.40625V5.64844H9.53906L9.1875 7.75781H7.40625V12H10.2422C11.2114 12 12 11.2114 12 10.2422V1.75781C12 0.788635 11.2114 0 10.2422 0Z\" fill=\"#C8C8C8\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol